<script setup lang="ts">
import { resolveRouteName } from '@/utils/utils'
import { navigateToLink } from '@/utils/nagivationService'

defineProps(['upperFooterData', 'propTradingLang'])
</script>
<template>
  <div class="3xl:min-w-[255px] lg:min-w-[170px] flex flex-col md:items-center md:justify-center">
    <ul class="leading-normal lg:text-lg">
      <p
        class="self-start md:self-center lg:self-start mb-[40px] text-lg lg:mb-[20px] 3xl:text-lg lg:leading-[24px] leading-normal lg:text-xl lg:font-bold"
      >
        {{ upperFooterData?.footer_column_one_title }}
      </p>
      <li class="mb-[20px] lg:mb-[10px] text-nowrap">
        <a
          :href="resolveRouteName(upperFooterData?.footer_column_one_links?.[0]?.link)"
          class="leading-normal hover:underline 3xl:text-lg"
          >{{ upperFooterData?.footer_column_one_links?.[0]?.label }}</a
        >
      </li>
      <li class="mb-[20px] lg:mb-[10px] text-nowrap">
        <a
          :href="resolveRouteName(upperFooterData?.footer_column_one_links?.[1]?.link)"
          class="leading-normal hover:underline"
          >{{ upperFooterData?.footer_column_one_links?.[1]?.label }}</a
        >
      </li>
      <li class="mb-[20px] lg:mb-[10px] text-nowrap">
        <a href="https://hantecprime.com/" class="leading-normal hover:underline">{{
          upperFooterData?.footer_column_one_links?.[2]?.label
        }}</a>
      </li>
      <li class="mb-[20px] lg:mb-[10px] text-nowrap">
        <a
          :href="resolveRouteName(upperFooterData?.footer_column_one_links?.[3]?.link)"
          class="leading-normal hover:underline"
          >{{ upperFooterData?.footer_column_one_links?.[3]?.label }}</a
        >
      </li>
      <!-- <li class="">
        <span
          @click="navigateToLink(upperFooterData?.footer_column_one_links?.[4]?.link)"
          class="leading-normal hover:underline cursor-pointer"
          >{{ upperFooterData?.footer_column_one_links?.[4]?.label }}</span
        >
      </li> -->
    </ul>
  </div>
</template>
